import { render, staticRenderFns } from "./config020-f-mianban.vue?vue&type=template&id=6e177510&"
import script from "./config020-f-mianban.vue?vue&type=script&lang=js&"
export * from "./config020-f-mianban.vue?vue&type=script&lang=js&"
import style0 from "./config020-f-mianban.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports